import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { showToast } from "./PopupMessage.jsx";
import {
  Box,
  Typography,
  Container,
  Card,
  CardMedia,
  Button,
  CircularProgress,
  Modal,
  IconButton,
  TextField,
  MenuItem,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { motion } from "framer-motion";
import DOMPurify from "dompurify";
import Navber from "../Components/Navber";
import api from "../Api"; // axios instance
import { ChevronLeft, ChevronRight } from "lucide-react";

const ActivityDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true);

  // Booking states
  const [openBooking, setOpenBooking] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [seats, setSeats] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);

  const accessToken = localStorage.getItem("accessTok");
  const FranchiseData = JSON.parse(localStorage.getItem("franchiseData")) || {};
  const customer_id = FranchiseData?.customer?.id || null;
  const franchise_id = FranchiseData?.franchise?.id || null;
  const customer = JSON.parse(localStorage.getItem("customer")) || {};

  const [index, setIndex] = useState(0);
  const [passengers, setPassengers] = useState([
    { name: "", email: "", phone: "", age: "", type: "adult" },
  ]);



  // AUTO SLIDE
  useEffect(() => {
    if (!activity?.images.length) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % activity?.images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [activity?.images.length]);

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? activity?.images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % activity?.images.length);
  };


  useEffect(() => {
    fetchActivityDetails();
  }, [id]);

  const handleNavigateAfterPayment = () => {
    window.location.href = "https://admin.jayrajgroup.org/admin/activity-bookings";
  };

  const fetchActivityDetails = async () => {
    try {
      const res = await api.get(`/activities/${id}`);
      setActivity(res.data.data);
      console.log("the activities details are ", res?.data?.data)
    } catch (err) {
      console.error("Error fetching activity:", err);
    } finally {
      setLoading(false);
    }
  };




  // 🔹 Open booking modal
  const handleOpenBooking = (destination) => {
    setSelectedDestination(destination);
    setSeats(1);
    setTotalAmount(destination.price);
    setOpenBooking(true);
    setPassengers([{ name: "", email: "", age: "", type: "adult" }]);


  };

  // 🔹 Close modal
  const handleCloseBooking = () => {
    setOpenBooking(false);
  };

  // 🔹 Change number of seats
  const handleSeatChange = (action) => {
    if (!selectedDestination) return;

    let newSeats = seats;

    if (action === "increase") {
      newSeats += 1;
      setPassengers((prev) => [
        ...prev,
        { name: "", email: "", age: "", type: "adult" },
      ]);
    }

    if (action === "decrease" && seats > 1) {
      newSeats -= 1;
      setPassengers((prev) => prev.slice(0, -1));
    }

    setSeats(newSeats);
    setTotalAmount(newSeats * selectedDestination.price);
  };
  const handlePassengerChange = (index, field, value) => {
    setPassengers((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };


  // 🔹 Razorpay Payment Integration
  const handlePayment = async () => {
    if (!selectedDestination) return;
    const isInvalid = passengers.some(
      (p) => !p.name || !p.email || !p.age
    );

    if (isInvalid) {
      showToast("Please fill all passenger details", "error");
      return;
    }



    try {
      const payload = {
        destination_id: selectedDestination.id,
        customer_id: customer_id,
        franchise_id: franchise_id,
        seats,
        total_amount: totalAmount,
        currency: "INR",
        passengers, // 👈 ARRAY
      };


      console.log("the payload before activity booking is ", payload)
      const order = await api.post(
        `/admin/activities/${activity?.id}/manual-book`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "X-ADMIN-TOKEN": `${accessToken}`,
          },
        }
      );

      console.log("Booking created:", order);

      showToast("Booking created successfully!", "success");
      handleNavigateAfterPayment(); 
      setOpenBooking(false);
    } catch (err) {
      console.error("Payment initiation error:", err);
      showToast(`${err?.message || "Failed to create booking.please try again from start"}`, "error");
    }
  };

  // 🔹 Loading state
  if (loading) {
    return (
      <Box
        sx={{
          height: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!activity) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 5 }}>
        Activity not found.
      </Typography>
    );
  }

  const sanitizedDescription = DOMPurify.sanitize(activity.description);

  return (
    <>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      <Container sx={{ py: 6 }}>
        {/* ✅ Layout Section */}
        <Box
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 4,
            alignItems: "stretch",
            justifyContent: "center",
          }}
        >
          {/* 🖼️ Image Section */}
          <Card
            sx={{
              width: { xs: "100%", md: "50%" },
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
              borderRadius: "15px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {/* SLIDE CONTAINER */}
            <Box
              sx={{
                display: "flex",
                transform: `translateX(-${index * 100}%)`,
                transition: "transform 0.6s ease-in-out",
                height: "100%",
              }}
            >
              {activity?.images.map((img, i) => (
                <CardMedia
                  key={i}
                  component="img"
                  image={img?.url}
                  alt={`slide-${i}`}
                  sx={{
                    minWidth: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ))}
            </Box>

            {/* PREV BUTTON */}
            <IconButton
              onClick={prevSlide}
              sx={{
                position: "absolute",
                top: "50%",
                left: 10,
                transform: "translateY(-50%)",
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
              }}
            >
              <ChevronLeft />
            </IconButton>

            {/* NEXT BUTTON */}
            <IconButton
              onClick={nextSlide}
              sx={{
                position: "absolute",
                top: "50%",
                right: 10,
                transform: "translateY(-50%)",
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#fff",
                "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
              }}
            >
              <ChevronRight />
            </IconButton>
          </Card>

          {/* 📋 Details Section */}
          <Card
            sx={{
              width: { xs: "100%", md: "50%" },
              p: 3,
              borderRadius: "15px",
              boxShadow: "0 2px 15px rgba(0,0,0,0.1)",
              background: "#fff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
            component={motion.div}
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <Box>
              <Typography
                variant="h4"
                sx={{ fontWeight: "bold", mb: 2, color: "#1976d2" }}
              >
                {activity.name}
              </Typography>

              <div
                dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                className="description_activity"
              />

              <Typography variant="h6" sx={{ mt: 2, fontWeight: "bold" }}>
                Available Destinations:
              </Typography>

              <Box sx={{ mt: 1 }}>
                {activity.destinations.map((d) => (
                  <Box
                    key={d.id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <Typography>{d.destination_name}</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography sx={{ fontWeight: "bold", color: "#1976d2" }}>
                        ₹{d.price.toLocaleString()}
                      </Typography>
                      <Button
                        size="small"
                        variant="outlined"
                        sx={{ borderRadius: "20px", textTransform: "none" }}
                        onClick={() => handleOpenBooking(d)}
                      >
                        Book
                      </Button>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Card>
        </Box>
      </Container>

      {/* 🧾 Booking Overlay Modal */}
<Modal
  open={openBooking}
  onClose={(event, reason) => {
    if (reason !== "backdropClick") {
      handleCloseBooking();
    }
  }}
  aria-labelledby="booking-modal-title"
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>

        <Box
          sx={{
            width: "90%",
            maxWidth: 500,
            maxHeight: "85vh",     // 🔒 fixed height
            overflowY: "auto",     // 🔥 enable scroll
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: 24,
            p: 3,
            pb: 1,
            position: "relative",
            scrollbarWidth: "thin", // For Firefox
          }}
        >

          <Typography
            id="booking-modal-title"
            variant="h5"
            sx={{ mb: 3, fontWeight: "bold", color: "#1976d2" }}
          >
            Book Your Seats
          </Typography>

          {/* Destination */}
          <TextField
            select
            fullWidth
            label="Destination"
            value={selectedDestination?.id || ""}
            sx={{ mb: 3 }}
          >
            {selectedDestination && (
              <MenuItem value={selectedDestination.id}>
                {selectedDestination.name}
              </MenuItem>
            )}
          </TextField>

          {passengers.map((p, index) => (
            <Box
              key={index}
              sx={{
                mb: 3,
                p: 2,
                border: "1px solid #eee",
                borderRadius: "12px",
              }}
            >
              <Typography sx={{ mb: 1, fontWeight: "bold" }}>
                Passenger {index + 1}
              </Typography>

              <TextField
                fullWidth
                label="Full Name"
                value={p.name}
                onChange={(e) =>
                  handlePassengerChange(index, "name", e.target.value)
                }
                sx={{ mb: 2 }}
              />

              <TextField
                fullWidth
                label="Email"
                type="email"
                value={p.email}
                onChange={(e) =>
                  handlePassengerChange(index, "email", e.target.value)
                }
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Phone"
                type="tel"
                value={p.phone || ""}
                onChange={(e) => handlePassengerChange(index, "phone", e.target.value)}
                required={index === 0}
                sx={{ mb: 2 }}
              />

              <TextField
                fullWidth
                label="Age"
                type="number"
                value={p.age}
                onChange={(e) =>
                  handlePassengerChange(index, "age", e.target.value)
                }
                sx={{ mb: 2 }}
              />

              <TextField
                select
                fullWidth
                label="Passenger Type"
                value={p.type}
                onChange={(e) =>
                  handlePassengerChange(index, "type", e.target.value)
                }
              >
                <MenuItem value="adult">Adult</MenuItem>
                <MenuItem value="child">Child</MenuItem>
                {/* <MenuItem value="infant">Infant</MenuItem> */}
              </TextField>
            </Box>
          ))}



          {/* Seats */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",

            }}
          >
            <Typography>Number of Seats:</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
              <IconButton color="primary" onClick={() => handleSeatChange("decrease")}>
                <Remove />
              </IconButton>
              <Typography sx={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                {seats}
              </Typography>
              <IconButton color="primary" onClick={() => handleSeatChange("increase")}>
                <Add />
              </IconButton>
            </Box>
          </Box>

          {/* Total */}
          <Typography
            variant="h6"
            sx={{ mb: 3, color: "#1976d2", fontWeight: "bold" }}
          >
            Total Amount: ₹{totalAmount.toLocaleString()}
          </Typography>

          {/* Buttons */}
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "#ffff",
              pt: 2,
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              borderTop: "1px solid #eee",

            }}
          >
            <Button variant="outlined" color="error" onClick={handleCloseBooking}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handlePayment}>
              Book Now
            </Button>
          </Box>

        </Box>
      </Modal>
    </>
  );
};

export default ActivityDetails;
